import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { ExportExcelService } from 'src/app/services/export-excel.service';
import { StorageService } from 'src/app/services/storage.service';
import { UserDashboardService } from 'src/app/services/user-dashboard.service';

@Component({
    selector: 'app-state-wise-distribution',
    templateUrl: './state-wise-distribution.component.html',
    styleUrls: ['./state-wise-distribution.component.scss'],
    standalone: false
})
export class StateWiseDistributionComponent implements OnInit {
  states: any;
  selectedState:any;
  amountbalance= '2.5cr';
  selectedDate: any;
  amountbalanceData: any=[];
  addNewBalanceForm : FormGroup;
  allocateAmount!:FormArray;
  submitted: boolean = false;
  selectedStateName: any;
      selectedAllocatedAmount: any;
      selectedMonth: any;
      displayBranch! : any ;
  constructor(private storageService:StorageService,private router: Router ,private formBuilder:FormBuilder ,   private userDashboardService:UserDashboardService,private cookieService: CookieService
    ,private exportExcelService:ExportExcelService) {
    this.addNewBalanceForm = this.formBuilder.group({
      allocateAmount: this.formBuilder.array([]),
      selectedStateName: [''],
      selectedAllocatedAmount:  [''],
      selectedMonth: ['']
      
   }); 
   this.userDashboardService.getBranchList().subscribe((res:any)=>{
     
     this.states = res['content'];
     this.displayBranch = this.storageService.getBranch() || null;
     this.displayBranch = this.displayBranch.name;
     
 })

  this.amountbalanceData= [
  {stateName: 'Maharashtra', allocatedAmount:'20 L', month:'June',status:'Available'},
   {stateName: 'Delhi', allocatedAmount:'14 L', month:'June',status:'Used'},
   {stateName: 'West Bengal', allocatedAmount:'22 L', month:'June',status:'Available' },
   {stateName: 'Karnataka', allocatedAmount:'16 L',month:'June',status:'Used' },
   {stateName: 'Telangana', allocatedAmount:'26 L', month:'June',status:'Available'},
   {stateName: 'MUMBAI', allocatedAmount:'23 L', month:'June',status:'Available' }
  
  ];
  }

  ngOnInit(): void {
  }

  removeDetails(index: number) {
    this.allocateAmountArray().removeAt(index);
  }

  allocateAmountArray(): FormArray {
    return this.addNewBalanceForm.get("allocateAmount") as FormArray;
  }

  addNewDetails() {
    this.allocateAmountArray().push(this.initDetails());


  }

  initDetails() {
    this.selectedMonth =this.addNewBalanceForm.controls['selectedMonth'].value.toLocaleString('default', { month: 'long' });
    return this.formBuilder.group({
      stateName: new FormControl(this.addNewBalanceForm.controls['selectedStateName'].value,[Validators.required]),
      allocatedAmount:new FormControl(this.addNewBalanceForm.controls['selectedAllocatedAmount'].value,[Validators.required]),
      status:new FormControl(''),
      month:new FormControl(this.selectedMonth,[Validators.required])
    });

  }

  pushToTable(){
    this.addNewDetails();
  }

  gotoDashboard(){
    this.router.navigate(['doqfy/admin-dashboard']);
  }

  numberOnly(event: any) {
    const pattern = /[0-9\-]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
  export(){
    this.exportExcelService.convertToExcel(this.amountbalanceData,'amountbalanceData');
  }
  getSelected(){
    this.cookieService.set('BranchName', this.selectedState);
  this.storageService.setBranch(this.selectedState)
  }
}
